import { Link, NavLink, useLocation } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { ReduxState } from 'types';
import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import * as languageActions from 'root/language/languageActions';
import ParkdLogoBlue from 'img/parkd-logo-blue.svg';
import SantaHat from 'img/santa-hat.png';
import StarRatingBox from './StarRatingBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faCreditCard, faGear, faHeadset, faParking, faRightFromBracket, faUsers } from '@fortawesome/free-solid-svg-icons';
import { authSlice } from 'features/auth/authSlice';
import { FeatureKey } from 'myParkdUtils/enums';
import PermissionGate from 'components/PermissionGate';
import { formatMessage } from 'i18n/CurrentLocale';


export const isChristmasPeriod = (date: Date = new Date()): boolean => {
    const month = date.getMonth();
    const day = date.getDate();
    // December 15-31
    if (month === 11 && day >= 15 && day <= 31) {
        return true;
    }
    // January 1–3
    if (month === 0 && day >= 1 && day <= 3) {
        return true;
    }

    return false;
};


const ParkdChristmasLogo = () => (
    <div id="parkd-header-logo-container">
        <img id='santa-hat' src={SantaHat} alt='Christmas logo' title={formatMessage({ id: 'SIDEBAR_HAPPY_HOLIDAYS' })} />
        <img id="parkd-header-logo" src={ParkdLogoBlue} alt="Parkd logo" />
    </div>
)


const ParkdLogoAndCompany = (props: any) => {
    return (
        <>
            {isChristmasPeriod()
                ? <ParkdChristmasLogo />
                : <img id="parkd-header-logo" src={ParkdLogoBlue} alt="Parkd logo" />
            }
            <div>
                {props.token && (
                    <Link to="/settings" id="company-name">{props.companyName}</Link>
                )}
            </div>
        </>
    )
}

const AppSidebar = (props: Props) => {

    const location = useLocation();

    return (
        <div id="app-sidebar">
            <div id="app-sidebar-container">

                <ParkdLogoAndCompany {...props} />

                <nav>
                    <ul>
                        <li>
                            <NavLink className={({ isActive }) => "menu-item" + (isActive ? " active" : "")} to="/sessions">
                                <FontAwesomeIcon icon={faParking} size='1x' />
                                <span>
                                    <FormattedMessage id="SIDEBAR_PARKING" />
                                </span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink className={({ isActive }) => "menu-item" + ((isActive || location.pathname === '/') ? " active" : "")} to="/vehicles">
                                <FontAwesomeIcon icon={faCar} size='1x' />
                                <span>
                                    <FormattedMessage id="SIDEBAR_VEHICLES" />
                                </span>
                            </NavLink>
                        </li>

                        <PermissionGate featureKey={FeatureKey.USER_MANAGEMENT}>
                            <li>
                                <NavLink className={({ isActive }) => "menu-item" + (isActive ? " active" : "")} to="/users">
                                    <FontAwesomeIcon icon={faUsers} size='1x' />
                                    <span><FormattedMessage id="SIDEBAR_USERS" /></span>
                                </NavLink>
                            </li>
                        </PermissionGate>

                        <PermissionGate featureKey={FeatureKey.PARKD_CARDS}>
                            <li>
                                <NavLink className={({ isActive }) => "menu-item" + (isActive ? " active" : "")} to="/parkd-cards">
                                    <FontAwesomeIcon icon={faCreditCard} size='1x' />
                                    <span><FormattedMessage id="SIDEBAR_PARKD_CARDS" /></span>
                                </NavLink>
                            </li>
                        </PermissionGate>

                        <li>
                            <NavLink className={({ isActive }) => "menu-item" + (isActive ? " active" : "")} to="/support">
                                <FontAwesomeIcon icon={faHeadset} size='1x' />
                                <span>
                                    <FormattedMessage id="GLOBAL_SUPPORT" />
                                </span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink className={({ isActive }) => "menu-item" + (isActive ? " active" : "")} to="/settings">
                                <FontAwesomeIcon icon={faGear} size='1x' />
                                <span>
                                    <FormattedMessage id="SIDEBAR_SETTINGS" />
                                </span>
                            </NavLink>
                        </li>
                        <li>
                            <a href="#" onClick={(e) => { e.preventDefault(); props.logout() }} id="logout-button" className="menu-item menu-item-logout">
                                <FontAwesomeIcon icon={faRightFromBracket} size='1x' />
                                <span>
                                    <FormattedMessage id="GLOBAL_LOGOUT" />
                                </span>
                            </a>
                        </li>
                    </ul>
                </nav>

                <StarRatingBox />

            </div>
        </div>
    )
}


type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps;


function mapStateToProps(state: ReduxState) {
    return {
        token: state.auth.token,
        companyName: state.companyDetails.companyDetails.name,
        companyCountryCode: state.companyDetails.companyDetails.address.countryCode,
        userLanguage: state.userLanguage.userLanguage
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        logout: authSlice.actions.logout,
        updateUserLanguage: languageActions.updateUserLanguage,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AppSidebar);